// extracted by mini-css-extract-plugin
module.exports = {"discount":"Discount_discount__33KZB","percent":"Discount_percent__-b-k8","medium":"Discount_medium__3XVee","large":"Discount_large__S7tzm","regular":"Discount_regular__1pZFM"};